import React from "react";
import "./ExaminationAccess.css";
import CamplaCoreService from "../../services/CamplaCoreService";

import {Button, Card, Col, Container, Row} from "react-bootstrap";
import Collapsible from "react-collapsible";
import ExamPasswordDialog from "./dialogs/examPasswordDialog/ExamPasswordDialog";
import ExaminationTableItem from "./examinationTableItem/ExaminationTableItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronLeft } from "@fortawesome/fontawesome-free-solid";
import { withTranslation } from "react-i18next";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import InstructionsDialog from "./dialogs/instructionsDialog/InstructionsDialog";
import UploadManagerDialog from "./dialogs/uploadManagerDialog/UploadManagerDialog";
import RunningExamination from "./runningExamination/RunningExamination";
import QRCode from "react-qr-code";
import {faCircleNotch, faDownload} from "@fortawesome/free-solid-svg-icons";
import ValidationHelper from "../../helpers/ValidationHelper";
import CamplaLernstickBridgeService from "../../services/CamplaLernstickBridgeService";
import RunningDownloadDialog from "../../components/dialogs/runningDownloadDialog/RunningDownloadDialog";
import {faApple, faWindows} from "@fortawesome/free-brands-svg-icons";

class ExaminationAccess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      examinations: [],
      examModules: [],
      moduleExams: {},
      qrcode: {
        status: 2,
        content: ""
      },
      challengeToken: null,
      runningExamination: null,
      startInstanceId: null,
      showPinCodeDialog: false,
      showInstructionDialog: false,
      showUploadDialog: false,
      selectedStudentExamination: null,
      waitingForExaminationStart: false,
      runningDownloadDialogShow: false,
      runningDownloadDialogTitle: "",
      runningDownloadDialogProgress: 0,
      dialogApiError: "",
      apiError: ""
    };

    this.defaultLoadingTimeout = {
      none: 22000,
      web: 6000,
      local: 1000
    }
    this.loadingTimeout = null;
    this.downloadLock = false;

    this.loadData = this.loadData.bind(this);
    this.handlePasswordRequest = this.handlePasswordRequest.bind(this);
    this.handleFileDownload = this.handleFileDownload.bind(this);
    this.handleRemoteAttestationStage = this.handleRemoteAttestationStage.bind(this);
    this.handleRemoteAttestation = this.handleRemoteAttestation.bind(this);
    this.orderExamsByModules = this.orderExamsByModules.bind(this);
    this.handleLernstickBridgeUpdates = this.handleLernstickBridgeUpdates.bind(this);
    this.handleCoreUpdates = this.handleCoreUpdates.bind(this);
    this.updateQRCode = this.updateQRCode.bind(this);
    this.handleSafeExamBrowserDownload = this.handleSafeExamBrowserDownload.bind(this);
    this.isLernstick = this.isLernstick.bind(this);
  }


  async handleRemoteAttestation(examinations){
    let hasOpenExaminations = false;
    for (const studExamination of examinations){
      if (studExamination.examination.status === 11){
        hasOpenExaminations = true;
      }
      // Check if examination is open and the instance is ready for remote attestation
      if (studExamination.examination.status === 11
          && localStorage.getItem("remoteAttestation") !== "activated"
          && (studExamination.examination.securityLevel === 3 || studExamination.examination.securityLevel === 4)
          && studExamination.instance.memberDevice !== null
          && (studExamination.instance.memberDevice.status === 10 || studExamination.instance.memberDevice.status === 12)){
        try {
            // Activate device
            await CamplaCoreService.activateRAOfInstance(studExamination.instance._id);
            localStorage.setItem("remoteAttestation", "activated");
            return;
        }catch (err){
            console.log(err);
        }
      }
    }
    if (!hasOpenExaminations){
      localStorage.removeItem("remoteAttestation");
    }
  }


  updateQRCode(status, content){
    this.setState({ qrcode: { status, content } });
  }

  async handleSafeExamBrowserDownload(os){
    try {
      if (window.sebDownloadRedirected){
        await CamplaCoreService.downloadSEBExternal(os);
      }else{
        const fileName = os === "macos" ? "SEB.dmg" :  "SEB_SetupBundle.exe";
        this.setState({
          runningDownloadDialogShow: true,
          runningDownloadDialogTitle: fileName,
          runningDownloadDialogProgress: 0
        });
        await CamplaCoreService.downloadSEB(
            os,
            fileName,
            percentage =>
                this.setState({ runningDownloadDialogProgress: percentage })
        );
        this.setState({
          runningDownloadDialogShow: false,
          runningDownloadDialogTitle: "",
          runningDownloadDialogProgress: 0
        });
      }

    }catch (err){
      this.setState({
        runningDownloadDialogShow: false,
        runningDownloadDialogTitle: "",
        runningDownloadDialogProgress: 0,
        apiError: APIErrorHelper.getError(
            err,
            () => this.setState({ apiError: "" }),
            {},
            this.props.t
        )
      });
    }
  }

  isLernstick(){
    try {
      const hasCAMPLAAddon = CamplaLernstickBridgeService.getInstance().hasCAMPLAAddon();
      const isLinuxFirefox = window.navigator.userAgent.indexOf("Linux") !== -1
      && window.navigator.userAgent.indexOf("Mozilla") !== -1;
      return hasCAMPLAAddon || isLinuxFirefox;
    }catch (err){}

    return false;
  }

  async handleRemoteAttestationStage(){
    // Check if hardware data is available and a valid remote attestation
    if (CamplaLernstickBridgeService.getInstance().getSystemObject() !== null
      && ValidationHelper.isRemoteAttestation(CamplaLernstickBridgeService.getInstance().getRemoteAttestationObject())){
      const currentQRCode = this.state.qrcode;
      try {
        // Stage device and request challenge
        const name = CamplaLernstickBridgeService.getInstance().getSystemObject().product.substring(0, 75);
        const stagingChallenge = await CamplaCoreService.stageMemberDevice({
          name,
          remoteAttestation: CamplaLernstickBridgeService.getInstance().getRemoteAttestationObject()
        });
        stagingChallenge["name"] = name;
        stagingChallenge["serial"] = CamplaLernstickBridgeService.getInstance().getSerial();
        CamplaLernstickBridgeService.getInstance().setStagingChallenge(stagingChallenge);

        // Renew QRCode for device staging
        this.updateQRCode(0, CamplaLernstickBridgeService.getInstance().generateQRCodeContent());
      }catch (err){
        this.updateQRCode(currentQRCode.status, currentQRCode.content);
        this.setState({
          apiError: APIErrorHelper.getError(
              err,
              () => this.setState({ apiError: "" }),
              {},
              this.props.t
          )
        });
      }
    }
  }


  async handleCoreUpdates(event){
    if ((event.action === "create" || event.action === "update") && event.model !== "instances") {
      const updatedState = await this.loadData();
      this.setState(updatedState);
    }
  }

  async handleLernstickBridgeUpdates(lernstickBridgeService){
    const examination = lernstickBridgeService.getRunningExamination();
    this.setState({runningExamination: examination});

    // Examination is running and loading timeout started
    if (examination && examination.isRunning){
      const defaultTimeout = typeof this.defaultLoadingTimeout[examination.examType] !== "undefined"
          ? this.defaultLoadingTimeout[examination.examType] : this.defaultLoadingTimeout.none;
      if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
      this.loadingTimeout = setTimeout(() => {
        this.setState({ waitingForExaminationStart: false});
        this.loadingTimeout = null;
      }, defaultTimeout);

    }

    this.updateQRCode(0, lernstickBridgeService.generateQRCodeContent());

  }

  async handlePasswordRequest(studentExamination) {
    if (!studentExamination) return;
    this.setState({ selectedStudentExamination: studentExamination });
    if (
        (studentExamination.examination.securityLevel === 5)
        || (
            (studentExamination.examination.securityLevel === 3
                || studentExamination.examination.securityLevel === 1
                || studentExamination.examination.securityLevel === 0)
            && !studentExamination.examination.hasPassword
        )
    ) {
      await this.handleFileDownload(studentExamination, "", "");
    } else {
      this.setState({ showPinCodeDialog: true });
    }
  }

  async handleFileDownload(studentExamination, pinCode, password) {
    try {
      if (this.downloadLock) return;
      this.downloadLock = true;

      if (typeof studentExamination.instance !== "undefined") {
        let raToken = CamplaLernstickBridgeService.getInstance().getRAToken();
        if ((studentExamination.examination.securityLevel === 3
            || studentExamination.examination.securityLevel === 4)
            && raToken === null){
          console.error("No remote attestation token found");
          raToken = "000";
        }
        let filename = "exam.campla";
        switch (studentExamination.examination.securityLevel){
          case 5:
          case 6:
            filename = "exam.seb";
            break;
          case 0:
            filename = "exam.zip";
            break;
        }

        const isLernstick = this.isLernstick();
        const isSEBExamination = studentExamination.examination.securityLevel === 5
            || studentExamination.examination.securityLevel === 6;

        if (isSEBExamination){
          this.setState({ startInstanceId: studentExamination.instance._id });
          setTimeout(() => this.setState({ startInstanceId: null }), 8000);
        }

        await CamplaCoreService.downloadExaminationFile(
          studentExamination.instance._id, pinCode, password, filename, raToken, isSEBExamination, isLernstick);

        this.setState({
          dialogApiError: "",
          waitingForExaminationStart: true,
          showPinCodeDialog: false
        });

        sessionStorage.setItem("runningExaminationId", studentExamination.instance._id);

        this.loadingTimeout = setTimeout(() => {
          this.setState({ waitingForExaminationStart: false });
          this.loadingTimeout = null;
        }, this.defaultLoadingTimeout.none);
      }
      this.downloadLock = false;
    } catch (err) {
      this.downloadLock = false;
      if (typeof err.status !== "undefined"
        && err.status === 403
        && CamplaLernstickBridgeService.getInstance().hasCAMPLAAddon()
        && sessionStorage.getItem("runningExaminationId") !== null
        && sessionStorage.getItem("runningExaminationId") === studentExamination.instance._id){
          this.setState({
            dialogApiError: "",
            showPinCodeDialog: false,
            waitingForExaminationStart: true
          });
          this.loadingTimeout = setTimeout(() => {
            this.setState({
              waitingForExaminationStart: false
            });
            this.loadingTimeout = null;
          }, this.defaultLoadingTimeout.none);
        }else{
          this.setState({
            dialogApiError: APIErrorHelper.getError(
                err,
                () => this.setState({ dialogApiError: "" }),
                {
                  PRECONDITION_FAILED:
                      "ExaminationAccess.APIError.PreconditionFailed",
                  NOT_FOUND: "ExaminationAccess.APIError.NotFound",
                  FORBIDDEN: "ExaminationAccess.APIError.Forbidden",
                  TOO_MANY_REQUESTS: "ExaminationAccess.APIError.TooManyRequests"
                },
                this.props.t
            )
          });
        }
    }
  }

  async componentDidMount() {
    // Lead current examination data
    const examinationData = await this.loadData();
    this.setState(examinationData);

    CamplaCoreService.addEventListener("examinationAccess", this.handleCoreUpdates);
    CamplaLernstickBridgeService.getInstance().addListener(this.handleLernstickBridgeUpdates);

    // Autostart:
    // - Only one examination exists (Then it is clear)
    // - User has the student role
    // - Examination is open and accessible
    // - Security level without PIN Code required
    // - No start password has been set
    const user = CamplaCoreService.getAuthenticatedUser();
    if (examinationData.examinations.length === 1
        && user.role === 2
        && examinationData.examinations[0].examination.autostart
        && examinationData.examinations[0].examination.status === 11
        && (examinationData.examinations[0].examination.securityLevel === 0
            || examinationData.examinations[0].examination.securityLevel === 1
            || examinationData.examinations[0].examination.securityLevel === 3
            || examinationData.examinations[0].examination.securityLevel === 5)
        && !examinationData.examinations[0].examination.hasPassword
        && sessionStorage.getItem("autostart") !== examinationData.examinations[0].examination._id){
      sessionStorage.setItem("autostart", examinationData.examinations[0].examination._id);
      this.handleFileDownload(examinationData.examinations[0], "", "");
    }
  }

  async loadData() {
    const examinations = await CamplaCoreService.getStudentExaminations();
    const examModules = Array.from(
      new Set(examinations.map(exam => exam.module.name))
    );

    //this.handleRemoteAttestation(examinations);

    const moduleExams = this.orderExamsByModules(examModules, examinations);
    CamplaLernstickBridgeService.getInstance().setExaminations(examinations);
    this.handleRemoteAttestation(examinations);
    return {
      examinations,
      examModules,
      moduleExams
    };
  }

  orderExamsByModules(examModules, examinations) {
    let moduleExams = {};

    examModules.forEach(module => {
      moduleExams[module] = examinations.filter(
        exam => exam.module.name === module
      );
    });
    return moduleExams;
  }

  render() {
    const { t } = this.props;
    const runningExamination = CamplaLernstickBridgeService.getInstance().getRunningExamination() ?
        (<RunningExamination
            onRemoteAttestationStage={this.handleRemoteAttestationStage}
            waitingForExaminationStart={this.state.waitingForExaminationStart}
            camplaLernstickBridgeService={CamplaLernstickBridgeService.getInstance()} />)
        : (<Row className="pageTitle">
          <Col>
            <h2>{t("ExaminationAccess.Title")}</h2>
          </Col>
        </Row>);


    const hasSEBExaminations = this.state.examinations
        .find(stuEx => stuEx.examination.securityLevel === 5 || stuEx.examination.securityLevel === 6);

    return (
      <div>
        <ExamPasswordDialog
            show={this.state.showPinCodeDialog}
            examination={this.state.selectedStudentExamination}
            onHide={() => this.setState({ showPinCodeDialog: false })}
            onSubmit={this.handleFileDownload}
            waitingForExaminationStart={this.state.waitingForExaminationStart}
            dialogApiError={this.state.dialogApiError}
        />
        <InstructionsDialog
            show={this.state.showInstructionDialog}
            studentExamination={this.state.selectedStudentExamination}
            onHide={() => this.setState({ showInstructionDialog: false })}
            dialogApiError={this.state.dialogApiError}
        />
        <UploadManagerDialog
            show={this.state.showUploadDialog}
            studentExamination={this.state.selectedStudentExamination}
            onHide={() => this.setState({ showUploadDialog: false })}
            dialogApiError={this.state.dialogApiError}
        />
        <RunningDownloadDialog
            show={this.state.runningDownloadDialogShow}
            onHide={() => this.setState({ runningDownloadDialogShow: false })}
            title={this.state.runningDownloadDialogTitle}
            progress={this.state.runningDownloadDialogProgress}
        />
        <Container className="mt-3">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          {runningExamination}
          <Row>
            {this.state.examModules.map((moduleName, idx) => (
              <Col key={idx}>
                <Card>
                  <Card.Body className="examCardBody">
                    <Collapsible
                      open={true}
                      trigger={
                        <Card.Title>
                          {moduleName}
                          <FontAwesomeIcon
                            icon={faChevronLeft}
                            style={{ float: "right" }}
                          />
                        </Card.Title>
                      }
                      triggerWhenOpen={
                        <Card.Title>
                          {moduleName}
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            style={{ float: "right" }}
                          />
                        </Card.Title>
                      }
                    >
                      {this.state.moduleExams[moduleName].map((ex, idx) => {
                        return (
                          <ExaminationTableItem
                            key={idx}
                            ex={ex}
                            runningExamination={this.state.runningExamination}
                            startInstanceId={this.state.startInstanceId}
                            onDownload={() => this.handlePasswordRequest(ex)}
                            onShowInstructions={() =>
                              this.setState({
                                showInstructionDialog: true,
                                selectedStudentExamination: ex
                              })
                            }
                            onUploadManager={() =>
                              this.setState({
                                showUploadDialog: true,
                                selectedStudentExamination: ex
                              })
                            }
                          />
                        );
                      })}
                    </Collapsible>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {hasSEBExaminations && !this.isLernstick() ? (<Row>
            <Col sm={12} className="mt-2">
              <div>
                <b className="mr-3">
                  <FontAwesomeIcon
                      icon={faDownload}
                      className="mr-1" /> SafeExamBrowser:
                </b>
                <Button
                    onClick={() => this.handleSafeExamBrowserDownload("windows")}
                    style={{width: "120px"}}
                    className="btn-green mr-2">
                  <FontAwesomeIcon
                      icon={faWindows}
                      className="mr-2" />
                  Windows
                </Button>
                <Button
                    onClick={() => this.handleSafeExamBrowserDownload("macos")}
                    style={{width: "120px"}}
                    className="btn-green mr-2">
                  <FontAwesomeIcon
                      icon={faApple}
                      className="mr-2" />
                  macOS
                </Button>
                <Button
                    href="https://apps.apple.com/us/app/safeexambrowser/id1155002964"
                    style={{width: "120px"}}
                    className="btn-green mr-2">
                  <FontAwesomeIcon
                      icon={faApple}
                      className="mr-2" />
                  iOS
                </Button>
              </div>
            </Col>
          </Row>): ""}
              {this.state.qrcode.status === 0 ? (<Row>
                <Col sm={12} className="mt-4">
                <QRCode
                    className="floatRight"
                    value={this.state.qrcode.content}
                    level="M"
                    size={200}
                />
              </Col>
              </Row>) : (this.state.qrcode.status === 1 ? <Row>
                <Col sm={12} className="mt-4">
                  <h2 className="floatRight pr-5">
                    <FontAwesomeIcon icon={faCircleNotch} spin />
                  </h2>
                </Col>
              </Row>: "")}
        </Container>
      </div>
    );
  }
}

export default withTranslation()(ExaminationAccess);
